import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setRem } from '@/utils/pxfromrem'
import api from './api'
import './styles/index.scss'
import 'vant/lib/icon/local.css'
import Clipboard from 'clipboard'
// 常用组件再这里引入
import {
  AddressList,
  Button,
  Card,
  DatetimePicker,
  Dialog,
  Divider,
  Field,
  Icon,
  NavBar,
  Notify,
  Popup,
  SubmitBar,
  Tab,
  Tabs,
  Search,
  Cell,
  CellGroup,
  AddressEdit
} from 'vant'

Vue.prototype.Clipboard = Clipboard

setRem(document, window)

Vue.use(Button).
  use(Icon).
  use(Popup).
  use(DatetimePicker).
  use(Tab).
  use(Tabs).
  use(Card).
  use(SubmitBar).
  use(Divider).
  use(Notify).
  use(NavBar).
  use(AddressList).
  use(Dialog).
  use(Field).
  use(Search).
  use(Cell).
  use(CellGroup).
  use(AddressEdit)
Vue.use(api)

Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  if (to.path === '/tmallelves') {
    window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
  }
  document.title = to.meta.title
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
